import { Dispatch } from 'redux';
import { schemaApi } from '../apis';
import { fetchCustomPersonSchemaSuccess } from './schemaReducer';

export const fetchCustomPersonSchema = () => async (dispatch: Dispatch) => {
  try {
    const customPersonSchema = await schemaApi.findCustomPersonSchema();
    dispatch(fetchCustomPersonSchemaSuccess(customPersonSchema));
  } catch (_) {
    //
  }
};
